import { isMentionType, MENTION_TYPES, Mention, MentionType } from './types';

const triggerForMentionType = (type: MentionType): '@' | '#' =>
  type === 'entity' || type === 'theme' ? '@' : '#';

/** `@[label](type:id)` / `#[label](type:id)` — FE marker format for REASON-2104. */
export const mentionToMarkerText = (mention: Mention): string =>
  `${triggerForMentionType(mention.type)}[${mention.label}](${mention.type}:${mention.id})`;

const MENTION_TYPE_PATTERN = MENTION_TYPES.join('|');
const MARKER_REGEX = new RegExp(
  `[@#]\\[([^\\]]+)\\]\\((${MENTION_TYPE_PATTERN}):([^)]+)\\)`,
  'g'
);

export const parseMentionMarkers = (text: string): (string | Mention)[] => {
  const segments: (string | Mention)[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(MARKER_REGEX)) {
    const [full, label, type, id] = match;
    const index = match.index ?? 0;

    if (index > lastIndex) {
      segments.push(text.slice(lastIndex, index));
    }

    if (isMentionType(type)) {
      segments.push({ type, id, name: label, label });
    }
    lastIndex = index + full.length;
  }

  if (lastIndex < text.length) {
    segments.push(text.slice(lastIndex));
  }

  return segments;
};

export const stripMentionMarkers = (text: string): string =>
  parseMentionMarkers(text)
    .map(segment => (typeof segment === 'string' ? segment : segment.label))
    .join('');

/**
 * Plain-text mention display:
 * - flag on → labels only (`aapl`)
 * - flag off → keep typed wire markers (`@[aapl](entity:aapl_nasd)`)
 */
export const toMentionPlainText = (
  text: string,
  mentionsEnabled: boolean
): string => (mentionsEnabled ? stripMentionMarkers(text) : text);
